import { useAuthStore } from '../stores/authStore'
import OperationalRoleDashboard from '../pages/dashboards/OperationalRoleDashboard'
import BursarDashboard from '../pages/dashboards/BursarDashboard'
import GovernanceDashboard from '../pages/GovernanceDashboard'
import HeadmasterDashboard from '../pages/dashboards/HeadmasterDashboard'
import DirectorOfStudiesDashboard from '../pages/dashboards/DirectorOfStudiesDashboard'
import LibrarianDashboard from '../pages/dashboards/LibrarianDashboard'
import SchoolDoctorDashboard from '../pages/SchoolDoctorDashboard'
import SchoolCounsellorDashboard from '../pages/dashboards/SchoolCounsellorDashboard'
import TransportManagerDashboard from '../pages/dashboards/TransportManagerDashboard'

export default function RoleBasedDashboard() {
  const role = useAuthStore((state) => state.user?.user_type)
  if (role === 'bursar') return <BursarDashboard />
  if (role === 'board_viewer' || role === 'donor_viewer') return <GovernanceDashboard />
  if (role === 'head_teacher') return <HeadmasterDashboard />
  if (role === 'director_of_studies') return <DirectorOfStudiesDashboard />
  if (role === 'librarian') return <LibrarianDashboard />
  if (role === 'school_doctor') return <SchoolDoctorDashboard />
  if (role === 'school_counsellor') return <SchoolCounsellorDashboard />
  if (role === 'transport_manager') return <TransportManagerDashboard />
  return <OperationalRoleDashboard />
}
